module.exports = __webpack_public_path__ + "images/category_lp/furniture/store_images/5_39b01d3c343da4471b1f2b66bdcf652a.png";